import Location from '../../../hooks/Location'
import useAdressMaterials from '../../../hooks/useAdressMaterials'
import formatEuro from '../../../helpers/formatEuro'
import ImpactUnknownNote from './ImpactUnknownNote'

/**
 * The two money figures a household's materials produce.
 *
 * Labelled as milieu-circulariteit 0.9 words its own three outcomes — bespaarde
 * CO2 sits on Co2SavedCard, the two euro figures here — so a number on this tab
 * can be traced back to the column of the document it came from.
 *
 * They are deliberately separate lines and never added together. The energy
 * bill saving is the household's own money; the maatschappelijke besparing is
 * what the saved emissions are worth to society at the standaard's shadow
 * price. The document publishes their sum as totaleWaardeEurPerJaar and warns
 * in the same breath that it is "geen kasgeld" — so it is not shown: summing
 * would double-count the same physical saving and mislabel whose money it is.
 */
const SocietalSavingsCard = () => {
    const adressId = Location()[3]
    const { impact, loading, impactError } = useAdressMaterials(adressId || '')

    // formatEuro turns null into €0,00, so guard before it: an unmeasurable
    // household must read as a dash, not as "saved nothing".
    const euro = (value) => (loading || value === null ? '—' : formatEuro(value))

    return (
        <div className='new-dashboard-card'>
            <div className='new-dashboard-card-content'>
                <h3 className='new-dashboard-card-title'>Besparingen</h3>
                <ul className='adress-dashboard-data-list'>
                    <li className='adress-dashboard-data-row'>
                        <span className='adress-dashboard-data-label'>Bespaard op energierekening</span>
                        <span className='adress-dashboard-data-value'>{euro(impact.privateEur)}</span>
                    </li>
                    <li className='adress-dashboard-data-row'>
                        <span className='adress-dashboard-data-label'>Maatschappelijke besparingen</span>
                        <span className='adress-dashboard-data-value'>{euro(impact.societalEur)}</span>
                    </li>
                </ul>
                <p className='adress-impact-sub'>per jaar</p>

                {!loading && (
                    <ImpactUnknownNote unknownCount={impact.unknownCount} error={impactError} />
                )}
            </div>
        </div>
    )
}

export default SocietalSavingsCard
